export default __webpack_public_path__ + "static/media/KW.18e22c27.svg";